/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Homepage constants
 */

export const TITLE = 'Zumper - Houses, Condos, and Apartments for Rent'
